<div class="p-4 light">
  <app-compare-print-header></app-compare-print-header>

  <app-compare-print-items></app-compare-print-items>

  <app-compare-print-footer></app-compare-print-footer>
</div>
